.mvWrapper {
    padding: 0 1.5rem;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: white;
    width: 100%;
    height: 60%;
    position: relative;
    z-index: 2;
    overflow: auto;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.5);

    @media screen and (min-width: 768px) {
        width: 50%;
        height: 100%;
        border-radius: 0;
        box-shadow: none;
    }
}

.mvTitle {
    margin-top: 1rem;
}

.mvPlusIcon {
    width: 14px;
    margin-right: 0.5rem;
}

.mvAddAreaButton {
    align-self: flex-start;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
}
